export type Field<T=string> = {
  value: T;
  isValid?: boolean;
  errorMessage?: string;
};
export const defaultValue:Field={
  value: '',
  isValid: false,
  errorMessage: 'required',

}
export type FormField<T> = {
  [K in keyof T]: Field<T[K]>;
};

export type __Field<T> = {
  [K in keyof T]: boolean ;
};

export const transformForm = <T extends Record<string, any>>(
  form: FormField<T> | __Field<T>
): { [K in keyof T]: string | number } => {
  const newForm: Partial<{ [K in keyof T]: string | number | boolean }> = {};

  for (const key in form) {
    if (form.hasOwnProperty(key) && key !== 'submitAttempt') {
      const value= (form[key] as Field).value?.toString().trim();
      newForm[key] = value;
    }
  }

  return newForm as { [K in keyof T]: string | number };
};



